import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import VersionHistory from 'src/components/common/VersionHistory';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { archLevel } from 'src/data/config';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import NotetoFileUXpage from './NotetoFileUXpage';
import { useNoteToFile } from './useNoteToFile';
import { DataTable } from '@pihealth/common-ui-library';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { GridColumns, GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
const DataGridNoteToFile: React.FunctionComponent<any> = (props: any) => {
  const { siteStudyPersonnelsData, setNoteToFileOpen, setStudyLogOpen } = props;
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const { selectedAppSection } = useSelectedAppInfo();
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [openNoteTofile, setOpenNoteTofile] = useState(false);
  const [viewNTFGrid, setNTFGrid] = useState(true);
  const {
    getAllNoteToFileData,
    getAllNoteToFileIsLoading,
    getAllNoteToFileIsSuccess,
    getAllNoteToFile,
    noteToFileData,
    getNoteToFileData,
    createNoteToFileData,
    createNoteToFile,
    createNoteToFileIsLoading,
    createNoteToFileIsSuccess
  } = useNoteToFile();
  const [ntfData, setNtfData] = useState({
    ntf_date: '',
    ntf_stdy_protocol_name: '',
    ntf_stdy_protocol_number: '',
    ntf_subject_id: '',
    ntf_description: '',
    ntf_issue: '',
    ntf_signed_on: null
  });
  const [rows, setRows] = useState<any>([]);
  const [selectedRow, setselectedRow] = useState<any>(null);
  const [filterObject, setFilterObject] = useState<any>();
  const handelBack = () => {
    setStudyLogOpen(true);
    setNoteToFileOpen(false);
  };
  const formatDate = (params: any) => {
    return getPreferredDateTimeInLocal(params.value);
  };

  const getAllNoteToFileFunc = (from: number, size: number) => {
    getAllNoteToFile({
      site_id: selectedSite,
      study_id: studyId,
      data: filterObject,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      ntf_level: archLevel.toUpperCase(),
      from,
      size
    });
  };
  const addNoteToFile = () => {
    createNoteToFile({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      application_section: selectedAppSection,
      ntf_level: archLevel.toUpperCase()
    });
  };
  const getFileData = () => {
    getNoteToFileData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,

      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      ntf_level: archLevel.toUpperCase(),
      note_to_file_id: selectedRow?.id
    });
  };
  const handleClickNoteToFile = (row: any) => {
    if (!isHierarchyLevelClosed) {
      setselectedRow(row);
    } else {
      dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
    }
  };
  const handleVersionHistory = async (selectedRow: any) => {
    setHedertitle(selectedRow.ntf_name);
    archLevel === 'site' ? setDocId(selectedRow?.tp_document_id_isf) : setDocId(selectedRow?.tp_document_id_etmf);
    setShowVersionHistory(true);
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Note To File ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  useEffect(() => {
    if (createNoteToFileData && createNoteToFileIsSuccess) {
      setPageNumber(0);
    }
  }, [createNoteToFileData, createNoteToFileIsSuccess]);
  useEffect(() => {
    setselectedRow(noteToFileData);
  }, [noteToFileData]);
  useEffect(() => {
    if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllNoteToFileFunc(0, pageSize);
      } else {
        getAllNoteToFileFunc(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize, createNoteToFileData, viewNTFGrid, studyId, selectedCountry, selectedSite, filterObject]);
  useEffect(() => {
    if (selectedSite === null) {
      handelBack();
    }
  }, [studyId, selectedCountry, selectedSite]);
  useEffect(() => {
    if (getAllNoteToFileData && getAllNoteToFileIsSuccess) {
      const tempData: any = getAllNoteToFileData?.selected_data.map((ele: any) => {
        return {
          ...ele,
          ntf_publish_version_isf: ele.ntf_publish_version_isf ? ele.ntf_publish_version_isf : `1.0`,
          ntf_publish_version_etmf: ele.ntf_publish_version_etmf ? ele.ntf_publish_version_etmf : `1.0`
        };
      });
      setRowsCount(getAllNoteToFileData?.record_count);
      setRows(tempData);
    } else {
      setRowsCount(0);
      setRows([]);
    }
  }, [getAllNoteToFileData, getAllNoteToFileIsSuccess]);
  useEffect(() => {
    if (selectedRow != null) {
      setOpenNoteTofile(true);
      setNTFGrid(false);
      getNoteToFileData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
        ntf_level: archLevel.toUpperCase(),
        note_to_file_id: selectedRow.id
      });
    }
  }, [selectedRow]);
  const columns: GridColumns = [
    {
      field: 'ntf_name',
      headerName: 'Log',
      minWidth: 240,
      flex: 1,
      renderCell: (params: any) => (
        <Link onClick={field => handleClickNoteToFile(params.row)}>{params.value?.toString()}</Link>
      )
    },
    {
      field: 'created_by',
      headerName: 'Initial Entry By',
      minWidth: 160,
      flex: 1,
      renderCell: params => {
        return params?.value || '-';
      }
    },
    {
      field: 'updated_by',
      headerName: 'Modified By',
      minWidth: 160,
      flex: 1,
      renderCell: params => {
        return params?.value || '-';
      }
    },
    {
      field: 'updated_on',
      headerName: 'Last Modified',
      width: 120,
      type: 'dateTime',
      minWidth: 200,
      valueGetter: formatDate,
      renderCell: params => {
        return params?.value || '-';
      }
    },
    {
      field: archLevel === 'site' ? 'ntf_publish_version_isf' : 'ntf_publish_version_etmf',
      headerName: 'Version',
      width: 80,
      renderCell: (params: any) => logVersions(params.row)
    }
  ];
  const logVersions = (row: any) => {
    const version = archLevel === 'site' ? row.ntf_publish_version_isf : row.ntf_publish_version_etmf;
    const retunVal =
      version !== null && version !== `1.0` ? (
        <Link onClick={field => handleVersionHistory(row)}>
          {version === 1 ? version.toFixed(1) : Number(version) > 0.9 ? Number(version).toFixed(1).toString() : version}
        </Link>
      ) : (
        Number(1.0).toFixed(1).toString()
      );
    return retunVal;
  };

  const dataTableProps = {
    filtermode: 'server'
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  return (
    <div>
      {viewNTFGrid ? (
        <>
          <div>
            <Box sx={{ marginBottom: 1, mt: -1 }}>
              <Button
                className="mainBackBtnWrap"
                onClick={() => handelBack()}
                startIcon={<ArrowBackIcon fontSize="small" />}
              >
                LIST OF LOGS
              </Button>
              <Button
                variant="contained"
                sx={{ float: 'right' }}
                onClick={addNoteToFile}
                disabled={
                  archLevel === 'site'
                    ? !checkPermission('add_site_note_to_file_studylogs')
                    : !checkPermission('add_sponsor_note_to_file_studylogs')
                }
              >
                ADD NOTE TO FILE
              </Button>
            </Box>
          </div>
          <DataTable
            hasDefinedColumns
            columns={columns}
            dataTableProps={dataTableProps}
            rows={rows}
            loading={getAllNoteToFileIsLoading || createNoteToFileIsLoading}
            datePreference={userPreferedDateFormat}
            paging
            rowsCount={rowsCount}
            pageNumber={pageNumber}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            paginationMode="server"
            className="studylogDatagrid"
            exportAll
            height="74vh"
            hasDefinedDataGridToolbarExport
            definedGridToolbarExport={definedCustomDatGridExport}
            filterValues={(data: any) => filterValues(data)}
          />
        </>
      ) : null}
      {openNoteTofile ? (
        <NotetoFileUXpage
          selectedRow={selectedRow}
          NoteToFileData={noteToFileData}
          setOpenNoteTofile={setOpenNoteTofile}
          setNTFGrid={setNTFGrid}
          siteStudyPersonnelsData={siteStudyPersonnelsData}
          setselectedRow={setselectedRow}
          ntfData={ntfData}
          setNtfData={setNtfData}
          getFileData={getFileData}
        />
      ) : (
        ''
      )}
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'Note To File'}
        />
      ) : (
        ''
      )}
    </div>
  );
};
export default DataGridNoteToFile;
